// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1nxSU","label":"Labeled_label__29xG7","divider":"Labeled_divider__Zcamo"};